<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh;">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" style="z-index:1" extended>
        <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">Pagos</v-toolbar-title>
        <v-toolbar-title v-show="$vuetify.breakpoint.xsOnly" style="width:100%">
          <v-flex class="titleSearch">
            <v-text-field
              class="mt-3"
              flat
              label="Buscar"
              prepend-inner-icon="search"
              solo-inverted
              clearable
              @click:append-outer="filterSearch"
              @click:clear="filterSearch"
              @keyup.enter="filterSearch"
              v-model="search"
            ></v-text-field>
          </v-flex>
        </v-toolbar-title>
        <v-tooltip right>
          <v-btn
            color="gradiente"
            dark
            :small="$vuetify.breakpoint.xsOnly"
            absolute
            bottom
            left
            fab
            slot="activator"
            @click="add"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span v-show="this.tab == 'payments'">Crear pago</span>
          <span v-show="this.tab == 'concepts'">Crear concepto</span>
        </v-tooltip>
        <template v-slot:extension>
          <v-layout row wrap>
            <v-flex xs12 md6 class="mt-3">
              <v-layout row wrap>
                <v-flex xs12 sm10 offset-sm1>
                  <v-tabs v-model="tab" color="transparent" grow>
                    <v-tabs-slider color="gradiente"></v-tabs-slider>
                    <v-tab href="#payments" :style="(tab) == 'payments' ? '':'text-decoration: underline;'">Pagos emitidos</v-tab>
                    <v-tab href="#concepts" :style="(tab) == 'concepts' ? '':'text-decoration: underline;'">Conceptos de pagos</v-tab>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md6 v-show="!$vuetify.breakpoint.xsOnly">
              <v-layout row wrap>
                <v-flex xs12 sm10 offset-sm2 class="titleSearch">
                  <v-text-field
                    flat
                    label="Buscar"
                    append-outer-icon="search"
                    clearable
                    solo-inverted
                    hide-details
                    @click:append-outer="filterSearch"
                    @click:clear="filterSearch"
                    @keyup.enter="filterSearch"
                    v-model="search"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </template>
      </v-toolbar>
      <v-container
        elevation-2
        fluid
        id="scrolling-activity"
        style="max-height: 75vh;"
        class="table-full"
      >
        <v-layout row wrap>
          <v-flex xs12>
            <v-tabs-items v-model="tab">
              <v-tab-item value="payments">
                <PaymentsTable
                  :user="getUser"
                  :showAddForm="showPaymentForm"
                  :search="filters.search"
                  @closedPopup="onClosedPopup"
                />
              </v-tab-item>
              <v-tab-item value="concepts">
                <v-flex xs12>
                  <PaymentsConceptsTable
                    :user="getUser"
                    :showAddForm="showConceptForm"
                    :search="filters.search"
                    @closedPopup="onClosedPopup"
                  />
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <alert v-model="toast.alert" title="Aviso" :description="toast.description"></alert>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import PaymentsTable from "../../Sections/Payments/PaymentsTable";
import PaymentsConceptsTable from "../../Sections/Payments/PaymentsConceptsTable";
import alert from "../../Dialogs/Alert";
export default {
  components: {
    PaymentsTable,
    PaymentsConceptsTable,
    alert,
  },
  data: () => ({
    filters: {
      search: "",
    },
    search: "",
    flags: {
      loading: false,
    },
    toast: {
      success: false,
      failed: false,
      alert: false,
      description: "No cuentas con los permisos necesarios para continuar con esta acción.",
    },
    modals: {
      createPayment: false,
    },
    showPaymentForm: false,
    showConceptForm: false,
    permits: [],
  }),
  methods: {
    mapPermits() {
      var usr = this.getUser;
      var wbRol = usr.webRole;
      var catalogs = wbRol.catalogs;
      for (var c in catalogs) {
        if (catalogs[c].name.includes("PAYMENTS")) {
          this.permits[catalogs[c].name] = 1;
        }
      }
    },
    
    filterSearch(val) {
      this.filters.search = this.search ? this.search : "";
    },
    add() {
      switch (this.tab) {
        case "payments":
          if (this.permits['ADD_PAYMENTS']) {
            this.showPaymentForm = true;
            this.showConceptForm = false;
          } else {
            this.toast.alert = true;
          }
          
          break;
        case "concepts":
          if (this.permits['ADD_PAYMENTS_CONCEPTS']) {
            this.showConceptForm = true;
            this.showPaymentForm = false;  
          } else {
            this.toast.alert = true;
          }
          break;
        default:
      }
    },
    onClosedPopup() {
      this.showPaymentForm = false;
      this.showConceptForm = false;
    },
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits();
    }
  },
  watch: {
    getUser() {
      this.mapPermits();
      if (
        this.permits["WATCH_STUDENTS"] &&
        !this.students.length > 0 &&
        this.getBranch.id
      ) {
        this.filters.size = 10;
        this.filters.offset = 0;
        this.filters.orderBy = "lastName";
        this.filters.orderType = "ASC";
        this.getStudentsOfBranch();
      }
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } });
      },
      get() {
        return this.$route.query.tab || "payments";
      },
    },
  },
};
</script>

<style>
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
</style>
<style scoped>
/deep/ .table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 426px);
  min-height: calc(100vh - 426px);
}
</style>
